import React from "react";
import flowers from "../data/bucheteTrandafiri";
import FlowerContainer from "../components/FlowerContainer";

const BucheteTrandafiri = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete Trandafiri"
      subtitle="Îmbinăm frumusețea clasică a trandafirilor cu flori atent alese pentru un efect spectaculos."
      storageKey="BUCHETE_TRANDAFIRI_SCROLL_POSITION"
    />
  );
};

export default BucheteTrandafiri;
